import { showLinearSolveWarning } from '@dealstack/frontend/app/pages/Valuations/components/LinearSolveWarning/linearSolveWarning.utils';
import { Icon } from '@dealstack/frontend/shared/components/fundament/Icon/Icon';
import { useTranslationValuations } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks';
import type { ValuationLinearSolveRes } from '@dealstack/shared/lib/generated';
import { VALUATION_ELEMENT_ID } from '@dealstack/shared/tests/testElementIds';
import { Alert, Text } from '@mantine/core';

export const LinearSolveWarning = ({ status }: { status?: ValuationLinearSolveRes }) => {
	const tValuations = useTranslationValuations();

	if (!showLinearSolveWarning(status)) {
		return null;
	}

	return (
		<Alert
			color="orange"
			variant="light"
			radius="sm"
			w="100%"
			icon={<Icon variant="warning" size="lg" />}
			data-testid={VALUATION_ELEMENT_ID.LINEAR_SOLVE_WARNING}
		>
			<Text size="sm" c="dark.8">
				{tValuations('summary.linear_solve_warning.not_exact')}
			</Text>
		</Alert>
	);
};
